import React from "react";
import User from "./components/User";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <User />
      <Footer />
    </div>
  );
}

export default App;
